import { isEmpty } from 'lodash';

export const isActionRestrictedHelper = (restrictions, restriction) => {
  if (isEmpty(restriction)) {
    return false;
  }

  return restrictions?.some((item) => restriction.includes(item));
};
